// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"558":"5241664a3ee7bf539c53","777":"c06a85400bca03415b55"}[chunkId] + ".js";
};